// @flow
import React from 'react';
import { Box, Text, Flex, Divider } from '@locus.sh/neo';
import type { TripInfo } from 'models/internal/TripInfo';
import { useTranslation } from 'react-i18next';

type Props = {
    tripInfo: TripInfo,
    styles?: Object,
};

const VehicleDetails = ({ tripInfo, styles }: Props) => {
    const { t } = useTranslation();
    const { vehicle } = tripInfo;

    if (!vehicle) {
        return null;
    }

    return (
        <Box sx={styles} backgroundColor="white">
            <Box p={4}>
                <Text fontWeight={600} color="grey.900" fontSize={2}>
                    {t('vehicleDetails')}
                </Text>
            </Box>
            <Box mb={4}>
                <Divider color="grey.300" />
            </Box>
            <Flex
                px={4}
                pb={4}
                justifyContent="space-between"
                alignItems="flex-start"
            >
                <Box>
                    <Text color="grey.600" fontSize={2} mb={1} fontWeight={500}>
                        {t('vehicleId')}
                    </Text>
                    <Text fontWeight={600} fontSize={2} color="grey.900">
                        {vehicle.id}
                    </Text>
                </Box>
                <Box>
                    <Text color="grey.600" fontSize={2} mb={1} fontWeight={500}>
                        {t('vehicleName')}
                    </Text>
                    <Text fontWeight={600} fontSize={2} color="grey.900">
                        {vehicle.name}
                    </Text>
                </Box>
                <Box></Box>
            </Flex>
        </Box>
    );
};

export default VehicleDetails;
